var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2742 25.4837L13.013 23.305C13.533 22.625 14.543 23.4937 13.973 24.1437C13.3742 24.8537 12.7442 25.6237 12.1442 26.4125L14.183 28.9512C14.733 29.7012 13.6342 30.42 13.0942 29.68L11.2542 27.3212L9.44549 29.7312C8.93549 30.46 7.80549 29.6412 8.37549 28.9612L10.3842 26.4125C9.75424 25.6225 9.14424 24.8537 8.53549 24.1437C7.90674 23.3937 9.07549 22.625 9.53549 23.3262L11.2742 25.4837Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 23.6837C15.4141 23.3537 15.6941 23.0737 16.0441 23.0737C16.3641 23.0737 16.6341 23.355 16.6341 23.6837V28.6912H19.3528C20.3316 28.6912 20.3528 30 19.3528 30H16.0453C15.6953 30 15.4153 29.7512 15.4153 29.3912V23.6837H15.4141Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2489 24.5837C21.4789 22.6437 24.4064 22.295 25.7864 23.355C26.4664 23.9037 25.7464 24.7737 25.1464 24.3337C24.4064 23.865 22.7276 23.645 22.5176 24.6825C22.2476 26.3225 26.5951 25.3837 26.5251 28.0425C26.4551 30.5812 22.7776 30.64 21.3976 29.5012C21.0664 29.2312 21.0776 28.7925 21.2576 28.5212C21.5176 28.2625 21.8064 28.1725 22.1476 28.4525C22.9664 29.0112 25.0764 29.4312 25.2251 28.0112C25.0964 26.5337 20.9389 27.4225 21.2489 24.5837Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.205a4a75cb89d6fcad7a334eb5b4c998.svg";
export { ForwardRef as ReactComponent };